// Test IDs for the platform-level clinic administration page (/plataforma).

export const PLATFORM_ADMIN = {
  page: 'platform-admin-page',
  tokenInput: 'platform-admin-token-input',
  connectButton: 'platform-admin-connect-button',
  tokenError: 'platform-admin-token-error',
  logoutButton: 'platform-admin-logout-button',

  clinicsTable: 'platform-admin-clinics-table',
  clinicRowPrefix: 'platform-admin-clinic-row-', // + tenantId
  statusBadgePrefix: 'platform-admin-status-badge-', // + tenantId
  deactivateButtonPrefix: 'platform-admin-deactivate-button-', // + tenantId
  activateButtonPrefix: 'platform-admin-activate-button-', // + tenantId
  deleteButtonPrefix: 'platform-admin-delete-button-', // + tenantId

  deleteDialog: 'platform-admin-delete-dialog',
  deleteConfirmInput: 'platform-admin-delete-confirm-input',
  deleteConfirmButton: 'platform-admin-delete-confirm-button',
  deleteCancelButton: 'platform-admin-delete-cancel-button',

  auditLogSection: 'platform-admin-audit-log-section',
  auditLogItemPrefix: 'platform-admin-audit-log-item-',
};
